/**
 * 에디터 공통 상수
 */

// 사이드바 접기/펼치기 버튼 스타일
export const SIDEBAR_TOGGLE = {
  ICON_SIZE: 16,
  ICON_STROKE_WIDTH: 3,
  WIDTH: 22,
  HEIGHT: 52,
  COLOR: '#6b7280',
  HOVER_COLOR: '#3b82f6',
  BG: '#ffffff',
  HOVER_BG: '#f3f4f6',
};

// canvas.toObject()에 전달할 커스텀 속성 목록
export const CANVAS_CUSTOM_PROPS = [
  'id', 'name', 'locked', 'selectable',
  'wordWrap', 'splitByGrapheme',
  '_layerExpanded',
  '_isTextBoxGroup', '_bgColor', '_bgAlpha', '_bgShape', '_borderColor', '_borderOpacity', '_borderWidth',
  '_isTableGroup', '_tableRows', '_tableCols', '_tableColWidths', '_tableRowHeights',
  '_isTableCell', '_isTableCellText', '_isTableBorder', '_borderDir',
  '_cellRow', '_cellCol', '_gridSpan', '_rowSpan',
  '_marL', '_marR', '_marT', '_marB', '_bullets',
  '_borders', '_origStroke', '_origStrokeWidth',
  '_isLineGroup', '_marker',
  '_isFrame', '_isEmptyFrame', '_frameShapeType', '_frameLocked',
  '_frameImageScale', '_frameWidth', '_frameHeight',
  '_origLeft', '_origTop', '_origScaleX', '_origScaleY',
  '_origWidth', '_origHeight', '_origAngle', '_origCropX', '_origCropY',
  '_isChart', '_chartType', '_chartSubType', '_chartTitle',
  '_chartTitleFontSize', '_chartTitleColor',
  '_chartSeries', '_chartAxes', '_chartLegend', '_chartDataPointColors',
  '_chartGapWidth', '_chartOverlap',
];

// 텍스트박스 기본 내부 여백 (PPT bodyPr 기본 inset: lIns/rIns=91440 EMU ≈ 7px, tIns/bIns=45720 EMU ≈ 4px)
export const DEFAULT_TEXT_INSET = { L: 7, R: 7, T: 4, B: 4 };

// 테이블 상수
export const TABLE_MIN_MARGIN = 5;          // 셀 상/하 마진 최솟값 (드래그 시 적용)
export const TABLE_MIN_ROW_HEIGHT = 30;     // 행 최소 높이
export const TABLE_MIN_COL_WIDTH = 20;      // 열 최소 너비
export const TABLE_CANVAS_PADDING = 20;     // 행/열 추가 시 캔버스 가장자리 여백
export const TABLE_MIN_NEW_SIZE = 30;       // 새 행/열 최소 크기 (이보다 작으면 축소 포기)

// 프리셋 색상
export const PRESET_COLORS = [
  // 기본
  '#000000', '#333333', '#666666', '#999999', '#cccccc', '#ffffff',
  // 비비드
  '#ef4444', '#f97316', '#eab308', '#22c55e', '#06b6d4', '#3b82f6', '#8b5cf6', '#ec4899',
  // 파스텔
  '#fca5a5', '#fdba74', '#fde047', '#86efac', '#67e8f9', '#93c5fd', '#c4b5fd', '#f9a8d4',
  // 다크
  '#991b1b', '#9a3412', '#854d0e', '#166534', '#155e75', '#1e40af', '#5b21b6', '#9d174d',
  // 뉴트럴
  '#78716c', '#a16207', '#4d7c0f', '#0e7490', '#4338ca', '#7e22ce', '#be185d', '#6b7280',
];

// 프리셋 그라데이션 (0°=좌→우, 90°=상→하, PPT/PSD 호환)
export const PRESET_GRADIENTS = [
  { type: 'linear', angle: 0, colorStops: [{ offset: 0, color: '#ff6b6b', opacity: 1 }, { offset: 1, color: '#feca57', opacity: 1 }] },
  { type: 'linear', angle: 0, colorStops: [{ offset: 0, color: '#a29bfe', opacity: 1 }, { offset: 1, color: '#6c5ce7', opacity: 1 }] },
  { type: 'linear', angle: 45, colorStops: [{ offset: 0, color: '#00b894', opacity: 1 }, { offset: 1, color: '#00cec9', opacity: 1 }] },
  { type: 'linear', angle: 0, colorStops: [{ offset: 0, color: '#fddb92', opacity: 1 }, { offset: 1, color: '#d1fdff', opacity: 1 }] },
  { type: 'linear', angle: 90, colorStops: [{ offset: 0, color: '#667eea', opacity: 1 }, { offset: 1, color: '#764ba2', opacity: 1 }] },
  { type: 'linear', angle: 315, colorStops: [{ offset: 0, color: '#f093fb', opacity: 1 }, { offset: 1, color: '#f5576c', opacity: 1 }] },
  { type: 'radial', colorStops: [{ offset: 0, color: '#ffffff', opacity: 1 }, { offset: 1, color: '#000000', opacity: 1 }] },
  { type: 'linear', angle: 0, colorStops: [{ offset: 0, color: '#4facfe', opacity: 1 }, { offset: 0.5, color: '#00f2fe', opacity: 1 }, { offset: 1, color: '#43e97b', opacity: 1 }] },
];

// 선 스타일
export const STROKE_STYLES = [
  { id: 'solid', label: '실선', dashArray: null },
  { id: 'dashed', label: '점선', dashArray: [10, 5] },
  { id: 'dotted', label: '점점선', dashArray: [2, 4] },
];

// 폰트 목록
export const FONTS = [
  { value: 'Noto Sans KR', label: 'Noto Sans KR' },
  { value: 'Noto Serif KR', label: 'Noto Serif KR' },
  { value: 'Pretendard', label: 'Pretendard' },
  { value: 'Arial', label: 'Arial' },
  { value: 'Verdana', label: 'Verdana' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Times New Roman', label: 'Times New Roman' },
  { value: 'Courier New', label: 'Courier New' },
];

// 폰트 크기
export const FONT_SIZES = [12, 14, 16, 18, 20, 24, 28, 32, 36, 48, 64, 72, 96];

// 텍스트 프리셋
export const TEXT_PRESETS = [
  { label: '제목', fontSize: 48, fontWeight: 'bold', displaySize: 18 },
  { label: '부제목', fontSize: 32, fontWeight: 'bold', displaySize: 15 },
  { label: '본문', fontSize: 18, fontWeight: 'normal', displaySize: 13 },
];

// 캔버스 크기 프리셋
export const CANVAS_SIZE_PRESETS = [
  { label: '1:1 (1080×1080)', width: 1080, height: 1080 },
  { label: '2:1 (1920×960)', width: 1920, height: 960 },
  { label: '1:2 (960×1920)', width: 960, height: 1920 },
  { label: '16:9 (1920×1080)', width: 1920, height: 1080 },
  { label: '9:16 (1080×1920)', width: 1080, height: 1920 },
];

// 라인 끝점 스타일
export const LINE_ENDPOINTS = [
  { id: 'none', label: '없음' },
  { id: 'arrow', label: '화살표' },
  { id: 'circle', label: '원' },
  { id: 'diamond', label: '다이아몬드' },
  { id: 'square', label: '사각형' },
];

// 도형 종류
export const SHAPE_TYPES = [
  { id: 'rect', label: '사각형' },
  { id: 'circle', label: '원' },
  { id: 'triangle', label: '삼각형' },
  { id: 'star', label: '별' },
  { id: 'polygon', label: '다각형' },
];
